<template>
  <div class="text-xs-center">
    <v-bottom-sheet v-model="active" inset hide-overlay lazy persistent>
      <v-card tile>
        <v-card-text>
          <v-layout row wrap>
            <v-flex
              xs12
              md10
              px-2
              d-flex
              align-center
              v-html="$t('terms.cookies.message')"
            />
            <v-flex xs12 md2 px-2 d-flex align-center>
              <v-btn color="primary" small dark @click="submit">
                {{ $t('action.buttons.accept') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: 'CookiesManager',
  data() {
    return {
      active: false,
    }
  },
  mounted() {
    if (!localStorage.getItem('cookies_state') && !this.$route.params.locale)
      this.active = true
  },
  methods: {
    submit() {
      localStorage.setItem('cookies_state', true)
      this.active = false
    },
  },
}
</script>
